import { jsx as _jsx } from "react/jsx-runtime";
import { Popover as PopoverPrimitive } from "@base-ui/react/popover";
import { cn } from "../../../utils";
/**
 * Base UI popover vendored from the shadcn `base-vega` registry. It is internal
 * to the date picker: the shared `Popover` export stays on Radix until a
 * dedicated migration.
 *
 * The root renders no DOM element of its own, so it carries no `data-slot` —
 * unlike the trigger and the popup, whose attributes styling rules target.
 */ const Popover = PopoverPrimitive.Root;
function PopoverTrigger({ ...props }) {
    return /*#__PURE__*/ _jsx(PopoverPrimitive.Trigger, {
        "data-slot": "popover-trigger",
        ...props
    });
}
function PopoverContent({ className, align = "center", alignOffset = 0, side = "bottom", sideOffset = 4, container, ...props }) {
    return /*#__PURE__*/ _jsx(PopoverPrimitive.Portal, {
        container: container,
        children: /*#__PURE__*/ _jsx(PopoverPrimitive.Positioner, {
            align: align,
            alignOffset: alignOffset,
            side: side,
            sideOffset: sideOffset,
            // `z-(--z-popover)`, not `z-popover`: Tailwind v4 has no `z-*` theme
            // namespace, so the bare name generates no rule at all and the popup
            // would ship at `z-index: auto`.
            className: "isolate z-(--z-popover)",
            children: /*#__PURE__*/ _jsx(PopoverPrimitive.Popup, {
                "data-slot": "popover-content",
                className: cn("z-(--z-popover) flex w-72 origin-(--transform-origin) flex-col gap-4 rounded-md bg-popover p-4 text-sm text-popover-foreground shadow-md ring-1 ring-foreground/10 outline-hidden duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", className),
                ...props
            })
        })
    });
}
export { Popover, PopoverContent, PopoverTrigger };

//# sourceMappingURL=popover.js.map